const elements = document.querySelectorAll(".wp-block-safirtema-lightboxyoutube[data-icon]");
elements.forEach(element => {
	const icon = element.dataset.icon;
	const iconElement = document.createElement("span");
	iconElement.classList.add("safiricon", "icon");
	iconElement.innerHTML = `<svg class="safiricon-${icon}"><use href="#safiricon-${icon}"></use></svg>`;
	element.appendChild(iconElement);
});